import { gql } from '@apollo/client';
import { CORE_THREAD_FIELDS, PLANNER_THREAD_FIELDS } from '../fragments/thread';
import { store } from '../../../redux/store';
import featureFlags from '../../featureFlags';

export const GET_THREADS = ({ withChildren = false } = {}) => gql`
  ${CORE_THREAD_FIELDS()}
  query GET_THREADS(
    $limit: Int
    $cursor: Int
    $stateIn: [String!]
    $search: String
    $channelId: Int
    $contactId: Int
    $boardId: Int
    $memberId: Int
    $sortByCreatedAt: OrderBy
    $sortByUpdatedAt: OrderBy
    $unassigned: Boolean
    $mentioned: Boolean
    $hasSchedule: Boolean
    $swarmState: SwarmState
    $id: Int
    $idIn: [Int!]
  ) {
    threads(
      limit: $limit
      cursor: $cursor
      search: $search
      filter: {
        state_in: $stateIn
        channel_id: $channelId
        contact_id: $contactId
        board_id: $boardId
        member_id: $memberId
        unassigned: $unassigned
        mentioned: $mentioned
        swarm_state: $swarmState
        has_schedule: $hasSchedule
        id: $id
        id_in: $idIn
      }
      order: { created_at: $sortByCreatedAt, updated_at: $sortByUpdatedAt }
      with_children: ${withChildren}
    ) {
      meta {
        limit
        offset
        has_more
        next_cursor
      }
      items {
        ...CoreThreadFields
      }
    }
  }
`;

export const GET_SINGLE_THREAD = () => gql`
  ${CORE_THREAD_FIELDS()}
  query GET_SINGLE_THREAD($id: Int, $systemId: Int) {
    thread(id: $id, system_id: $systemId) {
      ...CoreThreadFields
      parent_thread {
        ...CoreThreadFields
      }
    }
  }
`;

export const GET_LINKED_THREADS = () => gql`
  ${CORE_THREAD_FIELDS()}
  query GET_LINKED_THREADS(
    $limit: Int
    $offset: Int
    $threadId: Int!
    $sortByCreatedAt: OrderBy
    $sortByUpdatedAt: OrderBy
  ) {
    linkedThreads(
      limit: $limit
      offset: $offset
      thread_id: $threadId
      order: { created_at: $sortByCreatedAt, updated_at: $sortByUpdatedAt }
    ) {
      meta {
        limit
        offset
        has_more
        next_cursor
      }
      items {
        ...CoreThreadFields
      }
    }
  }
`;

export const GET_PLANNER_THREADS = () => {
  const { featureFlags: availableFeatureFlags = [] } = store.getState()?.users?.user || {};
  const isPlannerRTMCEnabled = availableFeatureFlags.includes(
    featureFlags.PLANNER_RESTRICT_TO_MEMBER_CHANNELS
  );

  return gql`
  ${PLANNER_THREAD_FIELDS}
  query GET_PLANNER_THREADS(
    $limit: Int
    $cursor: Int
    $stateIn: [String!]
    $search: String
    $channelId: Int
    $contactId: Int
    $boardId: Int
    $memberId: Int
    $sortByCreatedAt: OrderBy
    $sortByUpdatedAt: OrderBy
    $unassigned: Boolean
    $mentioned: Boolean
    $hasSchedule: Boolean
    $swarmState: SwarmState
    $id: Int
    $idIn: [Int!]
    $channelIds: [Int!]
    $boardIds: [Int!]
    $priorityIds: [Int!]
    $statusNames: [String!]
    $withChildren: Boolean
    $isPlanner: Boolean
  ) {
    threads(
      limit: $limit
      cursor: $cursor
      search: $search
      filter: {
        state_in: $stateIn
        channel_id: $channelId
        contact_id: $contactId
        board_id: $boardId
        member_id: $memberId
        unassigned: $unassigned
        mentioned: $mentioned
        swarm_state: $swarmState
        has_schedule: $hasSchedule
        id: $id
        id_in: $idIn
        channel_ids: $channelIds
        board_ids: $boardIds
        priority_ids: $priorityIds
        statuses: $statusNames
      }
      order: { created_at: $sortByCreatedAt, updated_at: $sortByUpdatedAt }
      with_children: $withChildren
      is_planner: $isPlanner
      ${isPlannerRTMCEnabled ? 'restrict_to_member_channels: true' : ''}
    ) {
      meta {
        limit
        offset
        has_more
        next_cursor
      }
      items {
        ...PlannerThreadFields
      }
    }
  }
`;
};
